import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { SharedModule } from 'app/shared/shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { PopupDetailComponent } from './popup-detail/popup-detail.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';

@NgModule({
    declarations: [
        NotificationsComponent,
        PopupDetailComponent
    ],
    imports     : [
        RouterModule,
        OverlayModule,
        PortalModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        SharedModule,
        TranslocoModule,
        PipesModule
    ],
    exports     : [
        NotificationsComponent
    ]
})
export class NotificationsModule
{
}
